import React from 'react';
import { ArhamGuide } from './mascot/ArhamGuide';
import { MascotMood, ArhamState, LanguageCode } from './mascot/mascotTypes';

export interface MascotProps {
  mood?: MascotMood;
  state?: ArhamState;
  message?: string;
  lang?: LanguageCode;
  onClick?: () => void;
  className?: string;
}

export default function Mascot({ mood = 'idle', state, message, lang = 'en', onClick, className }: MascotProps) {
  return (
    <ArhamGuide
      state={state}
      mood={mood}
      message={message}
      lang={lang}
      onClick={onClick}
      className={className}
    />
  );
}

export { ArhamGuide, ArhamAnimation } from './mascot';
export type { ArhamState, MascotMood } from './mascot';
